import { apiClient } from '@/shared/api/client';

/** Change Profile — 원래 회사(IS_MULTI_CSP=1) ↔ L_MULTI_CSP 프로필 전환 (백엔드 /api/changeprofile) */
export interface ChangeProfileItem { code: string; name: string | null; regNo: string | null }
export interface ChangeProfileList { current: string; owner: ChangeProfileItem; items: ChangeProfileItem[] }

// apiClient.get/post 는 응답 본문을 돌려줌 → 본문 { success, data } 의 data 가 결과
const body = <T>(res: unknown): T => ((res as { data?: T })?.data ?? {}) as T;

export const changeProfileApi = {
  /** 프로필 메뉴에 Change Profile 을 보일지(enabled)·CSP 프로필로 전환한 상태인지(inProfile) — 오류면 둘 다 false */
  async status(): Promise<{ enabled: boolean; inProfile: boolean; ownerName: string }> {
    try {
      const d = body<{ enabled?: boolean; inProfile?: boolean; ownerName?: string | null }>(await apiClient.get('/changeprofile/status'));
      return { enabled: !!d.enabled, inProfile: !!d.inProfile, ownerName: d.ownerName || '' };
    } catch {
      return { enabled: false, inProfile: false, ownerName: '' };
    }
  },
  async list(): Promise<ChangeProfileList> {
    return body<ChangeProfileList>(await apiClient.get('/changeprofile/list'));
  },
  async switch(code: string): Promise<{ code: string; name: string | null }> {
    return body<{ code: string; name: string | null }>(await apiClient.post('/changeprofile/switch', { code }));
  },
};
